<!--
 * @Description: 调研问卷的信息表格
 * @Date: 2021-11-09 09:49:17
-->

<template>
  <el-table
    border
    style="width: 100%"
    :stripe="true"
    :highlight-current-row="false"
    :data="[1]"
  >
    <el-table-column
      align="center"
      width="180px"
      v-for="(item, index) in tableData"
      :key="index"
      :show-overflow-tooltip="true"
      :label="item.label"
    >
      <template>
        <span>{{ item.values }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'task-data-for-5_7',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      taskFields: [
        { label: '问卷发起人', key: 'a' },
        { label: '发起人手机号', key: 'b' },
        { label: '开始时间', key: 'c' },
        { label: '结束时间', key: 'd' },
        { label: '答题时长', key: 'e' }
      ]
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
